import { IApplicationState } from '../../types/redux';

type TKnownOffersSourceState = Pick<IApplicationState, 'previewOffers' | 'listingOffers'>;

/** id офферов, которые надо запросить для превью: их ещё нет ни в листинге, ни в хранилище превью. */
export function selectPreviewOfferIdsToLoad(state: TKnownOffersSourceState, realtyIds: number[]): number[] {
  const knownIds = new Set([...state.listingOffers.offers, ...state.previewOffers.offers].map(offer => offer.id));

  return realtyIds.filter(realtyId => !knownIds.has(realtyId));
}
